import { render, staticRenderFns } from "./ClientProduct.vue?vue&type=template&id=6a9b241d&scoped=true&"
import script from "./ClientProduct.vue?vue&type=script&lang=js&"
export * from "./ClientProduct.vue?vue&type=script&lang=js&"
import style0 from "./ClientProduct.vue?vue&type=style&index=0&id=6a9b241d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9b241d",
  null
  
)

export default component.exports